module.exports = __webpack_public_path__ + "img/24m.3f8f3ceb.png";